var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "section-wrapper w-100" },
      [
        _c("div", { staticClass: "card pb-0", attrs: { id: "down-payment" } }, [
          _c(
            "div",
            {
              staticClass: "card-header px-5",
              attrs: { id: _vm._f("hashId")("mortgage-details[down-payment]") },
            },
            [
              _c("div", { staticClass: "row align-items-end" }, [
                _c("div", { staticClass: "col-12" }, [
                  _c("h2", { staticClass: "section-separator-title" }, [
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$t("application-form.down-payment-details")
                        ) +
                        "\n            "
                    ),
                  ]),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "card-body px-5 pb-5" },
            [
              _c(
                "group-set",
                {
                  attrs: {
                    "group-name": _vm.$t("application-form.down-payment"),
                    multi: !_vm.editVisibility,
                    path: "mortgage-details[down-payment]",
                    source:
                      _vm.currentApplication["mortgage-details"][
                        "down-payment"
                      ],
                    tabindex: "900",
                  },
                  on: { duplicate: _vm.handleDuplicate },
                },
                _vm._l(_vm.downPayment, function (downPaymentItem, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "row align-items-end mb-5",
                      attrs: {
                        id: _vm._f("hashId")(
                          "mortgage-details[down-payment][" + index + "]"
                        ),
                        "group-index": index,
                      },
                    },
                    [
                      _c("div", { staticClass: "col-12" }, [
                        _vm.currentApplication["mortgage-details"][
                          "down-payment"
                        ].length > 1
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "bold my-0 text-secondary form-title form-title-removable text-lowercase",
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(_vm.ordinalIndex(index)) +
                                    "\n                " +
                                    _vm._s(
                                      _vm.$t("application-form.down-payment")
                                    ) +
                                    "\n\n                "
                                ),
                                index > 0
                                  ? _c(
                                      "span",
                                      [
                                        _c("inline-prompt", {
                                          ref: "prompt",
                                          refInFor: true,
                                          staticClass:
                                            "d-inline-block bold text-gray ml-2",
                                          attrs: {
                                            "action-type": "delete",
                                            "confirmation-text": _vm.$t(
                                              "application.messages.allDataWillBeLost"
                                            ),
                                          },
                                          on: {
                                            accept: function ($event) {
                                              return _vm.handleRemove(
                                                index,
                                                "['mortgage-details']['down-payment']"
                                              )
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            )
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.downPayment +
                                "[" +
                                index +
                                "][source]",
                              _vm.visibilityPaths.downPayment +
                                "[" +
                                index +
                                "][description]",
                              _vm.visibilityPaths.downPayment +
                                "[" +
                                index +
                                "][amount]",
                            ],
                            title: _vm.editVisibility
                              ? _vm.ordinalIndex(index) +
                                " " +
                                _vm.$t("application-form.down-payment")
                              : _vm.$t("application-form.source"),
                            path:
                              _vm.visibilityPaths.downPayment +
                              "[" +
                              index +
                              "][source]",
                            "size-class": "col-lg-4 col-md-6 col-12",
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("select-section", {
                            attrs: {
                              name: "down-payment-source",
                              options: _vm.downPaymentSourceOptions,
                              tabindex: "900",
                            },
                            model: {
                              value: downPaymentItem.source,
                              callback: function ($$v) {
                                _vm.$set(downPaymentItem, "source", $$v)
                              },
                              expression: "downPaymentItem.source",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "hide-eye": true,
                            "visibility-paths": [
                              _vm.visibilityPaths.downPayment +
                                "[" +
                                index +
                                "][source]",
                              _vm.visibilityPaths.downPayment +
                                "[" +
                                index +
                                "][description]",
                              _vm.visibilityPaths.downPayment +
                                "[" +
                                index +
                                "][amount]",
                            ],
                            path:
                              _vm.visibilityPaths.downPayment +
                              "[" +
                              index +
                              "][description]",
                            "size-class":
                              "col-lg-4 col-md-12 col-12 order-lg-1 order-2",
                            title: _vm.$t("application-form.description"),
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              "visibility-paths": [
                                _vm.visibilityPaths.downPayment +
                                  "[" +
                                  index +
                                  "][source]",
                                _vm.visibilityPaths.downPayment +
                                  "[" +
                                  index +
                                  "][description]",
                                _vm.visibilityPaths.downPayment +
                                  "[" +
                                  index +
                                  "][amount]",
                              ],
                              "hide-eye": true,
                              name: "down-payment-description",
                              "max-length": "35",
                              tabindex: "900",
                              label: _vm.$t("application-form.description"),
                            },
                            model: {
                              value: downPaymentItem.description,
                              callback: function ($$v) {
                                _vm.$set(downPaymentItem, "description", $$v)
                              },
                              expression: "downPaymentItem.description",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "field",
                        {
                          attrs: {
                            "edit-visibility": _vm.editVisibility,
                            "visibility-paths": [
                              _vm.visibilityPaths.downPayment +
                                "[" +
                                index +
                                "][source]",
                              _vm.visibilityPaths.downPayment +
                                "[" +
                                index +
                                "][description]",
                              _vm.visibilityPaths.downPayment +
                                "[" +
                                index +
                                "][amount]",
                            ],
                            "hide-eye": true,
                            "size-class":
                              "col-lg-4 col-md-6 col-12 order-lg-2 order-1",
                            title: _vm.$t("application-form.amount"),
                            path:
                              _vm.visibilityPaths.downPayment +
                              "[" +
                              index +
                              "][amount]",
                            "container-class": "dollar-prepend",
                          },
                          on: { "toggle-visibility": _vm.handleVisibility },
                        },
                        [
                          _c("text-section", {
                            attrs: {
                              name: "down-payment-amount",
                              placeholder: "0",
                              "class-name": "fe-num-field dollar",
                              tabindex: "900",
                              label: _vm.$t("application-form.amount"),
                            },
                            model: {
                              value: downPaymentItem.amount,
                              callback: function ($$v) {
                                _vm.$set(downPaymentItem, "amount", $$v)
                              },
                              expression: "downPaymentItem.amount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "card-footer py-1 px-5 bg-light d-flex justify-content-end",
            },
            [
              _c(
                "field",
                {
                  attrs: {
                    "edit-visibility": _vm.editVisibility,
                    "hide-eye": true,
                    "size-class": "col-auto",
                    title: _vm.$t("application-form.total-down-payment"),
                    calculated: true,
                    "side-label": true,
                    "side-label-size": "col-auto",
                    "container-class": "dollar-prepend calculated",
                  },
                  on: { "toggle-visibility": _vm.handleVisibility },
                },
                [
                  _c("text-section", {
                    attrs: {
                      name: "total-down-payment",
                      placeholder: "0",
                      "class-name": "fe-num-field dollar calculated",
                      calculated: true,
                      value: _vm.calculatedValues.totalDownpaymentAmount,
                      loading: _vm.calculatedValues.loading,
                      label: _vm.$t("application-form.total-down-payment"),
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "d-flex align-items-center ml-1" },
                [
                  _c(
                    "inline-prompt",
                    {
                      staticClass: "clickable",
                      staticStyle: { "font-size": "0.8rem" },
                      attrs: {
                        "action-type": "edit",
                        placement: "top",
                        "accept-button-type": "primary",
                        "confirmation-text":
                          "i18n|application-form.copyTotalDownPayment",
                      },
                      on: {
                        accept: function ($event) {
                          return _vm.copyTotalDownPaymentToClosingDetails()
                        },
                      },
                    },
                    [
                      _c("icon", {
                        staticClass: "clickable",
                        attrs: { name: "calculator" },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "card pb-0", attrs: { id: "closing-details" } },
          [
            _c(
              "div",
              {
                staticClass: "card-header px-5",
                attrs: {
                  id: _vm._f("hashId")("mortgage-details[mortgage-details]"),
                },
              },
              [
                _c("div", { staticClass: "row align-items-center" }, [
                  _c("div", { staticClass: "col-11" }, [
                    _c("h2", { staticClass: "section-separator-title" }, [
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm.$t("application-form.closing-details")) +
                          "\n            "
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.editVisibility
                    ? _c(
                        "div",
                        { staticClass: "col" },
                        [
                          _c("multiple-visibility-button", {
                            attrs: {
                              "visibility-paths":
                                _vm.PagesVisibilityMap["closing-details"],
                            },
                            on: { "toggle-visibility": _vm.handleVisibility },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "card-body px-5" },
              [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    { staticClass: "col-xxl-4 col-xl-3 col-lg-12 col-12" },
                    [
                      _c(
                        "div",
                        { staticClass: "row align-items-end" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "visibility-paths": [
                                  _vm.visibilityPaths.closingDate,
                                ],
                                "size-class": "col-12 col-sm-4 col-xl-12",
                                title: _vm.$t("application-form.closing-date"),
                                icon: _vm.disabledByAcceptedSubmissionIcon,
                                "icon-tooltip":
                                  _vm.disabledByAcceptedSubmissionTooltipText,
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("date-section", {
                                attrs: {
                                  name: "closing-date",
                                  placeholder: "YYYY-MM-DD",
                                  "class-name": "date-format",
                                  disabled: _vm.anyAcceptedLenderSubmission,
                                  tabindex: "1000",
                                  label: _vm.$t(
                                    "application-form.closing-date"
                                  ),
                                },
                                on: { change: _vm.handleSave },
                                model: {
                                  value: _vm.closingDate,
                                  callback: function ($$v) {
                                    _vm.closingDate = $$v
                                  },
                                  expression: "closingDate",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          !_vm.editVisibility
                            ? _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "visibility-paths": [
                                      _vm.visibilityPaths.financingWaiver,
                                    ],
                                    "size-class": "col-12 col-sm-4 col-xl-12",
                                    title: _vm.$t(
                                      "application-form.date-of-financing-waiver"
                                    ),
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("date-section", {
                                    attrs: {
                                      name: "financing-waiver",
                                      placeholder: "YYYY-MM-DD",
                                      "class-name": "date-format",
                                      tabindex: "1000",
                                      label: _vm.$t(
                                        "application-form.date-of-financing-waiver"
                                      ),
                                    },
                                    on: { change: _vm.handleSave },
                                    model: {
                                      value: _vm.financingWaiver,
                                      callback: function ($$v) {
                                        _vm.financingWaiver = $$v
                                      },
                                      expression: "financingWaiver",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.editVisibility
                            ? _c(
                                "field",
                                {
                                  attrs: {
                                    "edit-visibility": _vm.editVisibility,
                                    "visibility-paths": [
                                      _vm.visibilityPaths.purpose,
                                    ],
                                    "size-class": "col-12 col-sm-4 col-xl-12",
                                    title: _vm.$t(
                                      "application-form.mortgage-purpose"
                                    ),
                                  },
                                  on: {
                                    "toggle-visibility": _vm.handleVisibility,
                                  },
                                },
                                [
                                  _c("text-section", {
                                    attrs: {
                                      name: "purpose",
                                      "max-length": "80",
                                      tabindex: "1000",
                                      label: _vm.$t(
                                        "application-form.mortgage-purpose"
                                      ),
                                    },
                                    model: {
                                      value: _vm.purpose,
                                      callback: function ($$v) {
                                        _vm.purpose = $$v
                                      },
                                      expression: "purpose",
                                    },
                                  }),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-xxl-8 col-xl-9 col-lg-12 col-12" },
                    [
                      _c(
                        "div",
                        { staticClass: "row align-items-end" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "size-class": "col-lg-5 col-sm-6 col-12",
                                "hide-eye": true,
                                title: _vm.$t(
                                  "application-form.property-value"
                                ),
                                "side-label": true,
                                "side-label-size": "col-sm-6 col-12",
                                "container-class":
                                  "dollar-prepend col-sm col-12",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "property-value",
                                  placeholder: "0",
                                  "class-name": "fe-num-field dollar",
                                  tabindex: "1000",
                                  label: _vm.$t(
                                    "application-form.property-value"
                                  ),
                                },
                                model: {
                                  value: _vm.propertyValue,
                                  callback: function ($$v) {
                                    _vm.propertyValue = $$v
                                  },
                                  expression: "propertyValue",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "row align-items-end" },
                        [
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "size-class": "col-lg-5 col-sm-6 col-12",
                                title: _vm.$t("application-form.down-payment"),
                                "side-label": true,
                                "side-label-size": "col-sm-6 col-5",
                                "container-class":
                                  "dollar-prepend col-sm col-12",
                                calculated: true,
                                "auto-calculated": false,
                                "visibility-paths": [
                                  _vm.visibilityPaths.downPayment + "[amount]",
                                ],
                                "hide-required-indicator": "",
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "down-payment-value",
                                  placeholder: "0",
                                  "class-name": "fe-num-field dollar",
                                  calculated: true,
                                  calculator: _vm.showDownPaymentCalculator,
                                  "auto-calculated": false,
                                  tabindex: "1000",
                                  label: _vm.$t(
                                    "application-form.down-payment"
                                  ),
                                },
                                on: {
                                  change: function (value) {
                                    return _vm.calculateDownpayment(
                                      value,
                                      "downpaymentPercent"
                                    )
                                  },
                                  calculate: function ($event) {
                                    return _vm.calculateMortgageDownpayment()
                                  },
                                },
                                model: {
                                  value:
                                    _vm.editableCalculatedValues
                                      .downpaymentAmount,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editableCalculatedValues,
                                      "downpaymentAmount",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "editableCalculatedValues.downpaymentAmount",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "field",
                            {
                              attrs: {
                                "edit-visibility": _vm.editVisibility,
                                "hide-eye": true,
                                "size-class": "col-lg-2 col-sm-3 col-12",
                                "container-class": "perc-append",
                                calculated: true,
                                "auto-calculated": false,
                                "visibility-paths": [
                                  _vm.visibilityPaths.downPayment + "[amount]",
                                ],
                              },
                              on: { "toggle-visibility": _vm.handleVisibility },
                            },
                            [
                              _c("text-section", {
                                attrs: {
                                  name: "down-payment-percentage",
                                  calculated: true,
                                  decimals: 2,
                                  "auto-calculated": false,
                                  percentage: "",
                                  placeholder: "0",
                                  "class-name": "fe-num-field rate",
                                  tabindex: "1000",
                                  label: _vm.$t(
                                    "application-standalone.labels.percentage"
                                  ),
                                },
                                on: {
                                  change: function (value) {
                                    return _vm.calculateDownpayment(
                                      value,
                                      "downpaymentAmount"
                                    )
                                  },
                                },
                                model: {
                                  value:
                                    _vm.editableCalculatedValues
                                      .downpaymentPercent,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editableCalculatedValues,
                                      "downpaymentPercent",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "editableCalculatedValues.downpaymentPercent",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      !_vm.editVisibility
                        ? _vm._l(3, function (_, mortgageIndex) {
                            return _c(
                              "div",
                              {
                                key: mortgageIndex,
                                staticClass: "row align-items-center",
                                attrs: {
                                  id: _vm._f("hashId")(
                                    "mortgage-details[mortgages][" +
                                      mortgageIndex +
                                      "]"
                                  ),
                                },
                              },
                              [
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.mortgages +
                                          "[" +
                                          mortgageIndex +
                                          "][amount]",
                                        _vm.visibilityPaths.mortgages +
                                          "[" +
                                          mortgageIndex +
                                          "][requested]",
                                        _vm.visibilityPaths.mortgages +
                                          "[" +
                                          mortgageIndex +
                                          "][insured]",
                                      ],
                                      path:
                                        _vm.visibilityPaths.mortgages +
                                        "[" +
                                        mortgageIndex +
                                        "][amount]",
                                      "size-class": "col-lg-5 col-sm-6 col-12",
                                      title:
                                        _vm.ordinalIndex(mortgageIndex) +
                                        " " +
                                        _vm.$t("application-form.mortgage"),
                                      "side-label": true,
                                      "clickable-title":
                                        _vm.navigateTitle(mortgageIndex),
                                      "side-label-size": "col-sm-6 col-12",
                                      "container-class":
                                        "dollar-prepend col-sm col-12",
                                      icon:
                                        _vm
                                          .disabledByAcceptedSubmissionIconByMortgage[
                                          _vm.mortgageIndexMap[mortgageIndex]
                                        ] || "",
                                      "icon-tooltip":
                                        _vm
                                          .disabledByAcceptedSubmissionTooltipTextByMortgage[
                                          _vm.mortgageIndexMap[mortgageIndex]
                                        ] || "",
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                      navigate: function ($event) {
                                        return _vm.navigateTo(
                                          "submission-details-" + mortgageIndex
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name:
                                          "mortgage-" +
                                          mortgageIndex +
                                          "-amount",
                                        "hide-eye": true,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.mortgages,
                                        ],
                                        calculator:
                                          _vm.mortgages[mortgageIndex]
                                            .requested === "requested",
                                        placeholder: "0",
                                        "class-name": "fe-num-field dollar",
                                        disabled:
                                          _vm
                                            .disabledByAcceptedSubmissionInputByMortgage[
                                            _vm.mortgageIndexMap[mortgageIndex]
                                          ],
                                        label: _vm.$t(
                                          "application-standalone.labels.percentage"
                                        ),
                                        tabindex: "1000",
                                      },
                                      on: {
                                        calculate: function ($event) {
                                          return _vm.calculateMortgageAmount(
                                            mortgageIndex
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.mortgages[mortgageIndex][
                                            "amount"
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.mortgages[mortgageIndex],
                                            "amount",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mortgages[mortgageIndex]['amount']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      "hide-eye": true,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.mortgages +
                                          "[" +
                                          mortgageIndex +
                                          "][amount]",
                                        _vm.visibilityPaths.mortgages +
                                          "[" +
                                          mortgageIndex +
                                          "][requested]",
                                        _vm.visibilityPaths.mortgages +
                                          "[" +
                                          mortgageIndex +
                                          "][insured]",
                                      ],
                                      path:
                                        _vm.visibilityPaths.mortgages +
                                        "[" +
                                        mortgageIndex +
                                        "][requested]",
                                      "size-class": "col-lg-2 col-sm-3 col-6",
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("select-section", {
                                      attrs: {
                                        "hide-eye": true,
                                        "visibility-paths": [
                                          _vm.visibilityPaths.mortgages +
                                            "[" +
                                            mortgageIndex +
                                            "][amount]",
                                          _vm.visibilityPaths.mortgages +
                                            "[" +
                                            mortgageIndex +
                                            "][requested]",
                                          _vm.visibilityPaths.mortgages +
                                            "[" +
                                            mortgageIndex +
                                            "][insured]",
                                        ],
                                        name:
                                          "mortgage-" +
                                          mortgageIndex +
                                          "-requested",
                                        placeholder: _vm.$t(
                                          "application-form.requested-or-existing"
                                        ),
                                        options: _vm.requestedOptionsByFlow,
                                        tabindex: "1000",
                                        disabled:
                                          _vm.isMortgageCoBrokered(
                                            mortgageIndex
                                          ),
                                      },
                                      on: {
                                        change: function (val) {
                                          return _vm.handleAddMortgage(
                                            mortgageIndex,
                                            val
                                          )
                                        },
                                      },
                                      model: {
                                        value:
                                          _vm.mortgages[mortgageIndex][
                                            "requested"
                                          ],
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.mortgages[mortgageIndex],
                                            "requested",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "mortgages[mortgageIndex]['requested']",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    attrs: {
                                      "edit-visibility": _vm.editVisibility,
                                      path:
                                        _vm.visibilityPaths.mortgages +
                                        "[" +
                                        mortgageIndex +
                                        "][insured]",
                                      "hide-eye": true,
                                      "visibility-paths": [
                                        _vm.visibilityPaths.mortgages +
                                          "[" +
                                          mortgageIndex +
                                          "][amount]",
                                        _vm.visibilityPaths.mortgages +
                                          "[" +
                                          mortgageIndex +
                                          "][requested]",
                                        _vm.visibilityPaths.mortgages +
                                          "[" +
                                          mortgageIndex +
                                          "][insured]",
                                      ],
                                      "size-class":
                                        "col-lg-auto col-sm-3 col-6",
                                    },
                                    on: {
                                      "toggle-visibility": _vm.handleVisibility,
                                    },
                                  },
                                  [
                                    _c("checkbox-section", {
                                      attrs: {
                                        checked:
                                          _vm.mortgages[mortgageIndex][
                                            "insured"
                                          ],
                                        disabled:
                                          !_vm.mortgages[mortgageIndex][
                                            "requested"
                                          ] ||
                                          _vm.isMortgageCoBrokered(
                                            mortgageIndex
                                          ),
                                        name:
                                          "mortgage-" +
                                          mortgageIndex +
                                          "-insured",
                                        label: _vm.$t(
                                          "application-form.insured"
                                        ),
                                        tabindex: "1000",
                                      },
                                      on: {
                                        change: function ($event) {
                                          _vm.mortgages[mortgageIndex][
                                            "insured"
                                          ] = $event
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "field",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.totalAmountCondition(
                                            mortgageIndex
                                          ),
                                        expression:
                                          "totalAmountCondition(mortgageIndex)",
                                      },
                                    ],
                                    attrs: {
                                      "hide-eye": true,
                                      "size-class":
                                        "col-xl-2 col-lg col-sm-3 col-12 offset-lg-0 offset-sm-9",
                                      "container-class":
                                        "dollar-prepend calculated",
                                      calculated: true,
                                    },
                                  },
                                  [
                                    _c("text-section", {
                                      attrs: {
                                        name: "amount-plus-insurance-premium-0",
                                        value: _vm.totalLoanAmount(
                                          _vm.mortgageIndexMap[mortgageIndex]
                                        ),
                                        placeholder: "0",
                                        "class-name":
                                          "fe-num-field calculated dollar",
                                        calculated: true,
                                        loading: _vm.calculatedValues.loading,
                                        tabindex: "1000",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          })
                        : _vm._e(),
                    ],
                    2
                  ),
                ]),
                _vm._v(" "),
                !_vm.editVisibility
                  ? _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _c(
                          "field",
                          {
                            attrs: {
                              "edit-visibility": _vm.editVisibility,
                              "visibility-paths": [
                                _vm.visibilityPaths.improvements,
                                _vm.visibilityPaths.improvementsValue,
                                _vm.visibilityPaths.improvementsDescription,
                              ],
                              title: _vm.editVisibility
                                ? _vm.$t("application-form.improvements")
                                : "",
                              "size-class": "ml-3",
                            },
                            on: { "toggle-visibility": _vm.handleVisibility },
                          },
                          [
                            _c("checkbox-section", {
                              attrs: {
                                name: "improvements",
                                label: _vm.editVisibility
                                  ? ""
                                  : _vm.$t("application-form.improvements"),
                                tabindex: "1000",
                              },
                              model: {
                                value: _vm.improvements,
                                callback: function ($$v) {
                                  _vm.improvements = $$v
                                },
                                expression: "improvements",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                !_vm.editVisibility
                  ? _c(
                      "transition-group",
                      {
                        staticClass: "row",
                        attrs: { name: "slide-fade", tag: "div" },
                      },
                      [
                        _vm.editVisibility ||
                        _vm.visibilityToggle(
                          _vm.currentApplication,
                          _vm._visibilityDataContext,
                          "['mortgage-details']['mortgage-details']['improvements']",
                          _vm.binaryTrueShowsOptions,
                          "improvementsValue"
                        )
                          ? _c(
                              "field",
                              {
                                key: "improvementsValue",
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.improvementsValue,
                                  ],
                                  "depends-upon": [
                                    _vm.visibilityPaths.improvements,
                                  ],
                                  "size-class": "col-md-4 col-12",
                                  title: _vm.$t(
                                    "application-form.improvement-value"
                                  ),
                                  "container-class": "dollar-prepend",
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    name: "monthly-income",
                                    placeholder: "0",
                                    "class-name": "dollar fe-num-field",
                                    tabindex: "1000",
                                    label: _vm.$t(
                                      "application-form.improvement-value"
                                    ),
                                  },
                                  model: {
                                    value: _vm.improvementsValue,
                                    callback: function ($$v) {
                                      _vm.improvementsValue = $$v
                                    },
                                    expression: "improvementsValue",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.editVisibility ||
                        _vm.visibilityToggle(
                          _vm.currentApplication,
                          _vm._visibilityDataContext,
                          "['mortgage-details']['mortgage-details']['improvements']",
                          _vm.binaryTrueShowsOptions,
                          "improvementsDescription"
                        )
                          ? _c(
                              "field",
                              {
                                key: "improvementsDescription",
                                attrs: {
                                  "edit-visibility": _vm.editVisibility,
                                  "visibility-paths": [
                                    _vm.visibilityPaths.improvementsDescription,
                                  ],
                                  "depends-upon": [
                                    _vm.visibilityPaths.improvements,
                                  ],
                                  "size-class": "col-md-8 col-12",
                                  title: _vm.$t(
                                    "application-form.improvement-description"
                                  ),
                                },
                                on: {
                                  "toggle-visibility": _vm.handleVisibility,
                                },
                              },
                              [
                                _c("text-section", {
                                  attrs: {
                                    name: "improvement-description",
                                    tabindex: "1000",
                                    label: _vm.$t(
                                      "application-form.improvement-description"
                                    ),
                                  },
                                  model: {
                                    value: _vm.improvementsDescription,
                                    callback: function ($$v) {
                                      _vm.improvementsDescription = $$v
                                    },
                                    expression: "improvementsDescription",
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ]
        ),
        _vm._v(" "),
        !_vm.editVisibility
          ? _c(
              "group-set",
              {
                attrs: {
                  id: _vm._f("hashId")("submission-details"),
                  "group-name": _vm.$t("application-form.mortgage"),
                  multi: !_vm.editVisibility,
                  path: "[submission-details]",
                  source: _vm.emptyApplication["submission-details"],
                  "start-empty": false,
                  "add-as-button": true,
                  limit: 3,
                  "hide-add-button": true,
                  "generate-skeleton": false,
                },
                on: {
                  duplicate: function ($event) {
                    return _vm.handleAddMortgage(null)
                  },
                },
              },
              _vm._l(_vm.submissionDetails, function (mortgage, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    attrs: {
                      id: _vm._f("hashId")("submission-details[" + index + "]"),
                    },
                  },
                  [
                    _c("submission-details", {
                      key:
                        "submission-details-mortgage-" +
                        mortgage["submission-details"]["mortgage-type"],
                      attrs: {
                        "path-name": "submission-details[" + index + "]",
                        "mortgage-index-selector": index,
                        "current-mortgage-type":
                          mortgage["submission-details"]["mortgage-type"],
                        "current-mortgage-data": _vm.getMortgageData(mortgage),
                        "edit-visibility": _vm.editVisibility,
                        "current-application": _vm.currentApplication,
                        "calculated-values": _vm.getCalculatedValues(
                          mortgage["submission-details"]["mortgage-type"]
                        ),
                        "submission-details-length":
                          _vm.submissionDetails.length,
                      },
                      on: {
                        "toggle-visibility": _vm.handleVisibility,
                        save: _vm.handleSave,
                      },
                    }),
                  ],
                  1
                )
              }),
              0
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }